import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { fontFamily, fontSize } from '../../../../../constants/text';
import { colors } from '../../../../../constants/colors';

const Row = styled.li`
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  border-top: ${colors.greyDim} 1px solid;

  &:first-child {
    border-top: none;
  }
`;

const Item = styled.span`
  font-family: ${fontFamily.book};
  font-size: ${fontSize.mediumSmall};
  ${({ highlighted }) => css`
    color: ${highlighted ? colors.crunchBerry : colors.blueMonday};
    font-family: ${highlighted ? fontFamily.medium : fontFamily.book};
  `}
`;

const HourRow = props => {
  const { day, hours, highlighted, content } = props;
  return (
    <Row itemProp="openingHours" content={content}>
      <Item highlighted={highlighted}>{day}</Item>
      <Item highlighted={highlighted}>{hours}</Item>
    </Row>
  );
};

HourRow.propTypes = {
  day: PropTypes.string.isRequired,
  hours: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  highlighted: PropTypes.bool,
};

export default HourRow;
